import script from "./icon-arrow-lite.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-arrow-lite.vue?vue&type=script&lang=ts&setup=true"

import "./icon-arrow-lite.vue?vue&type=style&index=0&id=7ea9a0fe&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ea9a0fe"]])

export default __exports__